import { styled, createGlobalStyle } from 'styled-components'
import { screen } from './mq'
import { ColorType } from '../types'

export const Container = styled.div`
  width: 100%;
  max-width: 120rem;
  margin: 0 auto 12rem;
  padding-inline: var(--padding-l);

  @media (max-width: ${screen.m}) {
    max-width: 100%;
    margin: 0 auto 8rem;
    padding-inline: var(--padding-m);
  }
  @media (max-width: ${screen.s}) {
    margin: 0 auto 6rem;
    padding-inline: var(--padding-s);
  }
  @media (max-width: ${screen.xs}) {
    padding-inline: var(--padding-xs);
  }
  h2 span {
    font-size: 1.8rem;
    font-weight: normal;
    opacity: 0.6;
  }
  p span {
    color: var(--highlight);
  }
`
export const GlobalStyle = createGlobalStyle<{ $colors: ColorType }>`
:root {
  --dark: ${props => props.$colors.background};
  --main: ${props => props.$colors.main};
  --second: ${props => props.$colors.second};
  --highlight: ${props => props.$colors.highlight};
  --light: ${props => props.$colors.light};
  --padding-l: 6rem;
  --padding-m: 2.4rem;
  --padding-s: 1.2rem;
  --padding-xs: 0.8rem;
  --gap: 2.4rem;
}


* {
    box-sizing: border-box;
}

html {
    font-size: 62.5%;
}
body {


    font-size: 1.6rem;
    line-height: 1.6;
    @media (max-width: ${screen.m}) {
    font-size: 1.5rem;
  }
  @media (max-width: ${screen.s}) {
    font-size: 1.4rem;
  }
  @media (max-width: ${screen.xs}) {
    font-size: 1.3rem;
  }
}
html, body {
    width: 100%;  
    margin:0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--dark);
    color: var(--main);
    font-family: "Montserrat", sans-serif;
    font-optical-sizing: auto;
    font-style: normal;
    overflow-x: clip;
    /*background-image: url('images/Background.jpg');
    background-size: cover;
    background-blend-mode: dark-light;
    background-image:radial-gradient(farthest-corner at 25% 40%, #10151e,#181E29);*/
}
a {
    text-decoration: none;
}
p a {
    color: ${props => props.$colors.highlight};
    text-decoration: none;
    border-bottom: 1px solid var(--highlight);
    &:hover {
      transition: all 0.5s;
      color: var(--light);
      border-bottom: 1px solid var(--light);
    }
}
button {
    display: flex;
    align-items: center;
    height: 32px;
    font-weight: 700;
    border-radius: 16px;
    padding: 8px 16px;
    background: transparent;
    border: 2px solid ${props => props.$colors.main};
    color: ${props => props.$colors.light};
    cursor: pointer;
    transition: all .5s;
    &:hover {
        background: ${props => props.$colors.second};
    }
  }
.light {
  color:var(--light);
}
.yellow {
  color: var(--third);
}
h1, h2 {
  color: var(--light);
  }
h3 {
  color:var(--light);
  }

.inset-shadow {
  box-shadow: inset 5px 5px 10px rgba(0, 0, 0, 0.4), inset -4px -4px 10px rgba(255, 255, 255, 0.03);
  }

.outer-shadow {
  box-shadow:  2px 2px 5px rgba(0, 0, 0, 0.4), -2px -2px 5px rgba(255, 255, 255, 0.1);
  }
`
